import React, {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom'

interface TechnologyVersionProps {
	server: string;
	pageData: unknown;
}

export default function TechnologyVersion({server, pageData}: TechnologyVersionProps) {

	let [data, setData] = useState(pageData);

	return (
		<>
			<h1>If you see this page that means 302 redirect to version/websites page did not work</h1>
		</>
	)
};
